	

export const init = () =>{
	const hd=document.querySelector(".common_Include_Header_new");
	const ft=document.querySelector(".common_Include_Footer_new");
	
	if(hd!==null){
		movMainNew();
		gnavControlNew();
		spNavLoopNew();
	}
	
	if(ft!==null){
		setPageTopBtNew();
		imageDragOut();
		visibleBody();
		getMeta();
	}
	
	
}
const imageDragOut = () => {
	const elements = document.querySelectorAll("img");
	const disableDraggingFor = (o) =>{
		o.draggable = false;
		o.onmousedown = function(event) {
			event.preventDefault();
			return false;
		};
	}
	
	
	for (var i = elements.length; i--; ) {
		disableDraggingFor(elements[i]);
	}
}
const spNavLoopNew = () =>{
	let element = document.querySelector('.st-HeaderLogo_Item');
	let style = window.getComputedStyle(element);
	let cssJg = ("block" === style.getPropertyValue('display'));
	
	let clsBt=document.querySelectorAll(".spMenuClose a,.navBackBt a");
	let strtBt=document.querySelector(".wa-skipLink a");
	
	for(let c=0;c<clsBt.length;c++){
		
		clsBt[c].addEventListener("keydown", (event) => {
			console.log("strt")
			let tabKey = ( 9 === event.keyCode );
			let shiftKey = event.shiftKey;
			
			if(!shiftKey && tabKey && clsBt[c] === document.activeElement ){
				strtBt.focus();
			}
		});
	}
}
const movMainNew = () =>{
	let contBt=document.getElementById("wa-skipLink").querySelector("a");
	contBt.addEventListener("click",(e) =>{
		e.preventDefault();
		let cont=document.querySelector("main");
		let contTop=cont.getBoundingClientRect().top;
		let contFstA=cont.querySelector("a");
		contFstA.focus();
		window.scrollTo({top:contTop,behavior: 'smooth'});
		return false;
	})
}







/************************グローバルナビ制御 start************************/
const gnavControlNew = () =>{
	/************************PC用ナビ制御************************/
	
	/**PC用変数**/
	let gNav=document.getElementById("gnvNew");
	let contBt=gNav.querySelectorAll(".newNavMain > li button");
	
	/**SP用変数**/
	let spHmBt=document.querySelector(".spMenuBt");
	let backBt=gNav.querySelectorAll(".navBackBt a");
	let firstBt=gNav.querySelector(".newNavMain").children;
	let firstSubBts=gNav.querySelector(".newNavSub");
	let closeBt=gNav.querySelector(".spMenuClose a");
	
	
	
	contBt.forEach((element) => {
		let targMenu=element.nextElementSibling;
		
		element.parentNode.addEventListener("mouseover",() =>{
			if(window.innerWidth >=769){
				targMenu.hidden = false;
				element.setAttribute('aria-expanded', 'true');
			}
			
		});
		element.parentNode.addEventListener("mouseleave",() =>{
			if(window.innerWidth >=769){
				targMenu.hidden = true;
				element.setAttribute('aria-expanded', 'false');
			}
		});
		
		element.addEventListener("focusin", () => {
			if(window.innerWidth >=769){
				targMenu.hidden = false;
				element.setAttribute('aria-expanded', 'true');
			}
			
		});
		
		element.parentNode.addEventListener("focusout", (ev) => {
			if(window.innerWidth >=769){
				if (!ev.currentTarget.contains(ev.relatedTarget)) {
					targMenu.hidden = true;
					element.setAttribute('aria-expanded', 'false');
				}
			}
			
		}, true);
		
		element.addEventListener("click", () => {
			targMenu.hidden = !targMenu.hidden;
			if('true' === element.getAttribute('aria-expanded')){
				element.setAttribute('aria-expanded', 'false');
				Array.from(firstBt).forEach((bt) => {
					bt.querySelector("a,button").classList.remove("inert");
				});
				firstSubBts.classList.remove("inert");
				closeBt.classList.remove("inert")
			}else{
				element.setAttribute('aria-expanded', 'true');
				Array.from(firstBt).forEach((bt) => {
					bt.querySelector("a,button").classList.add("inert");
				});
				firstSubBts.classList.add("inert");
				closeBt.classList.add("inert");
			}
			
		});
	});
	
	
	/************************SP用ナビ制御************************/
	
	
	spHmBt.addEventListener("click",() =>{
		event.preventDefault();
		SpMenuOpClNew(gNav);
	});
	
	closeBt.addEventListener("click",() =>{
		event.preventDefault();
		SpMenuOpClNew(gNav);
	});
	
	
	backBt.forEach((element) => {
		element.addEventListener("click",() =>{
			event.preventDefault();
			Array.from(firstBt).forEach((bt) => {
				//bt.querySelector("a,button").inert = false;
				bt.querySelector("a,button").classList.remove("inert");
			});
			//firstSubBts.inert = false;
			firstSubBts.classList.remove("inert");
			closeBt.classList.remove("inert");
			element.closest(".mainSubMenu").hidden=!element.closest(".mainSubMenu").hidden;
			element.closest(".mainSubMenu").previousElementSibling.setAttribute('aria-expanded', 'false');
		});
	});
	
}

const SpMenuOpClNew = (gNav) =>{
	let spHmBt=document.querySelector(".spMenuBt");
	let mainCont=document.querySelector("main");
	let footCont=document.querySelector(".common_Include_Footer_new");
	let body=document.querySelector("body");
	let visMen=document.querySelectorAll(".mainSubMenu:not([hidden])");
	let inerts=gNav.querySelectorAll(".inert");
	
	gNav.hidden = !gNav.hidden;
	
	if (gNav.hidden) {
		spHmBt.setAttribute('aria-expanded', 'false');
		spHmBt.innerHTML="MENU";
		mainCont.classList.remove("inert");
		footCont.classList.remove("inert");
		body.classList.remove("scrollLock");
		
		visMen.forEach((trg) => {
			trg.hidden=true;
			trg.previousElementSibling.setAttribute('aria-expanded', 'false');
		});
		inerts.forEach((inert) => {
			inert.classList.remove("inert");
		});
	}else{
		spHmBt.setAttribute('aria-expanded', 'true');
		spHmBt.innerHTML="CLOSE";
		mainCont.classList.add("inert");
		footCont.classList.add("inert");
		body.classList.add("scrollLock");
	}
}

/************************グローバルナビ制御 end************************/



/************************ページトップ移動ボタン制御 start************************/
const setPageTopBtNew = () =>{
	const mvTp=document.querySelector(".st-PageTop");
	const pgFt=document.querySelector(".st-Footer_Bottom");
	const observer = new IntersectionObserver(function(trg) {
		trg.forEach(obj => {
			if (obj.isIntersecting) {
				mvTp.classList.add("is-scrolled");
			}else{
				mvTp.classList.remove("is-scrolled");
			}
		});
	},{
		root: null,
		rootMargin: "0px 0px",
		threshold: 0
	});
	observer.observe(pgFt);
	
	
	mvTp.addEventListener("click",(e) =>{
		e.preventDefault();
		let pgFstA=document.querySelector("h1 a");
		let flg=true;
		window.scrollTo({
			top: 0,
			left:0,
			//behavior: "smooth"
		});
		window.addEventListener("scrollend", () => {
			if(flg){
				pgFstA.focus();
			}
			flg=false;
		});
	});
}
/************************ページトップ移動ボタン制御 end************************/


/************************SNSボタン start************************/
let metaSet={};
const getMeta =()=>{
    var metas = document.getElementsByTagName('meta');
    for (let j = 0; j < metas.length; j++) {
        if (metas[j].getAttribute('property') === "og:url") {
            metaSet.url=metas[j].getAttribute('content');
        }else if (metas[j].getAttribute('property') === "og:title") {
            metaSet.title=metas[j].getAttribute('content');
        }else if (metas[j].getAttribute('property') === "og:description") {
             metaSet.description=metas[j].getAttribute('content');
        }
    }

    
    let snsTag=document.getElementsByClassName("st-FooterSNS_Btn");
    for(let s=0;s<snsTag.length;s++){
        if(snsTag[s].classList.contains('st-FooterSNS_Btn--facebook') == true){
            snsTag[s].href="https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(metaSet.url);
        }else if(snsTag[s].classList.contains('st-FooterSNS_Btn--twitter') == true){
            snsTag[s].href="https://twitter.com/share?text="+encodeURIComponent(metaSet.title)+encodeURIComponent(metaSet.description)+"&url="+encodeURIComponent(metaSet.url);
        }else if(snsTag[s].classList.contains('st-FooterSNS_Btn--line') == true){
            snsTag[s].href="https://social-plugins.line.me/lineit/share?url="+encodeURIComponent(metaSet.url);
        }
        //snsTag[s].href="test";
    }
}
/************************SNSボタン end************************/


const visibleBody =()=>{
	const Body=document.querySelector("body");
	Body.classList.add("visible")
}

